import { render, staticRenderFns } from "./dptfrom.vue?vue&type=template&id=73a2570e&scoped=true"
import script from "./dptfrom.vue?vue&type=script&lang=js"
export * from "./dptfrom.vue?vue&type=script&lang=js"
import style0 from "./dptfrom.vue?vue&type=style&index=0&id=73a2570e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2570e",
  null
  
)

export default component.exports